export default __webpack_public_path__ + "static/media/frame_zh_cn_sp.2ae3b2c0.png";